export default "__VITE_ASSET__uFauCEXf__"